import i18n, {
  getExplicitLanguage,
  isSupportedLanguage,
  saveLanguagePreference,
  writeLanguageCookie,
} from "./index";
import axiosInstance from "../services/axiosInstance";

// Aturan sinkronisasi bahasa (sama semangatnya dengan comity-apps):
// - Pilihan eksplisit di browser ini (switcher console / landing page) adalah sumber kebenaran.
// - Bila belum ada pilihan eksplisit, bahasa akun di server (users.language) dipakai,
//   sehingga bahasa ikut ke perangkat baru setelah login.
// - Pilihan eksplisit yang berbeda dari server dikirim ulang ke server (retry setiap profil dimuat).
// - Bila server belum mendukung kode bahasanya, sinkronisasi dilewati tanpa mengganggu UI.

const pushToServer = (code) =>
  axiosInstance.post("console/user/language", { language: code }).catch(() => {});

export const setLanguage = async (code, { syncServer = true } = {}) => {
  if (!isSupportedLanguage(code)) return;

  await i18n.changeLanguage(code);
  saveLanguagePreference(code);
  writeLanguageCookie(code);

  if (syncServer) {
    pushToServer(code);
  }
};

export const syncLanguageWithUser = async (user) => {
  if (!user?.user_id || !("language" in user)) return;

  const explicit = getExplicitLanguage();
  const serverLang = user.language;

  if (!explicit) {
    if (isSupportedLanguage(serverLang) && serverLang !== i18n.language) {
      await i18n.changeLanguage(serverLang);
    }
    return;
  }

  if (explicit !== serverLang) {
    pushToServer(explicit);
  }
};
